export enum MailingJobCondition {
    None,
    NotYetApproved
}